import { MascaraCpf } from "../../../utils/MascaraCpf";
import { MascaraTelefone } from "../../../utils/MascaraTelefone";
import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { Typography, Button, Card, Divider, Chip, TablePagination, TextField, Autocomplete, MenuItem, Select, Checkbox, FormControlLabel, InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Box, FormControl, InputLabel, OutlinedInput, FormHelperText, Tabs, Tab, Alert, Collapse } from "@mui/material";
import { Visibility, VisibilityOff, Email as EmailIcon, VerifiedUser as VerifiedUserIcon, } from "@mui/icons-material";
import { MascaraCnpj } from "../../../utils/MascaraCnpj";
import { TirarMascara } from "../../../utils/TirarMascara";
import { MascaraCep } from "../../../utils/MascaraCep";
import { FormatarData } from "../../../utils/FormatarData";
import ModalImage from "./ModalImage";
import { NumericFormat } from 'react-number-format';
import { useParams, useSearchParams } from "react-router-dom";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import UploadFileIcon from "@mui/icons-material/UploadFile";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { MascaraCelular } from "../../../utils/MascaraCelular";
import servicesCode from "../../../data/ServicesCode";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Switch from '@mui/material/Switch';
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
import FormLabel from '@mui/material/FormLabel';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import DownloadIcon from "@mui/icons-material/FileDownloadOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import { Tooltip } from "@mui/material";
import { ptBR } from "date-fns/locale";
import { DataGrid } from "@mui/x-data-grid";
import MotivoCancelamentoNfse from "./ModalMotivoCancelamentoNfse";
import PageLayout from "../../../components/layout/PageLayout";
import SectionCard from "../../../components/ui/SectionCard";
import StatusChip from "../../../components/ui/StatusChip";
import { notify, confirmDialog, getErrorMessage } from "../../../components/feedback/notify";
import { FormatDate } from "../../../utils/FormatDate";
import { formatToBrl } from "../../../utils/FormatToBrl";
import { statusNota, podeBaixarPdf, podeCancelar, tomadorNota, mensagemNota } from "../../../utils/StatusNotaFiscal";

// Formata o código de serviço (ex.: "010101" -> "01.01.01").
const formatarCodigoServico = (codigo) => String(codigo || "").replace(/\D/g, "").match(/.{1,2}/g)?.join(".") || "";

// Grade de campos responsiva: 1 coluna no mobile, `cols` a partir de md.
const FieldGrid = ({ cols = "1fr 1fr", children, sx }) => (
    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: cols }, gap: 2, ...sx }}>
        {children}
    </Box>
);

const SubTitulo = ({ children, description }) => (
    <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle1">{children}</Typography>
        {description && <Typography variant="body2" color="text.secondary">{description}</Typography>}
    </Box>
);

const ABAS = ["emissao", "empresa", "cadastro", "movimentacoes"];

function PerfilUsuario(props) {
    const { idUsuario } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const abaAtual = ABAS.includes(searchParams.get("aba")) ? searchParams.get("aba") : "emissao";
    const trocarAba = (_, valor) => setSearchParams((prev) => {
        const params = new URLSearchParams(prev);
        params.set("aba", valor);
        return params;
    }, { replace: true });

    const [idNotaSelecionadaParaCancelamento, setIdNotaSelecionadaParaCancelamento] = useState(null);

    const columns = [
        {
            field: "idNota",
            headerName: "ID",
            width: 80, // mantém largura fixa
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            minWidth: 130,
            renderCell: (params) => {
                const { label, tone } = statusNota(params.value);
                const motivo = mensagemNota(params.row);
                return (
                    <Tooltip title={motivo}>
                        <span><StatusChip label={label} tone={tone} /></span>
                    </Tooltip>
                );
            },
        },
        {
            field: "tomador",
            headerName: "Tomador",
            flex: 1.5,
            minWidth: 160,
            valueGetter: (_, row) => tomadorNota(row) || "-",
        },
        {
            field: "valor",
            headerName: "Valor",
            flex: 1,
            minWidth: 140,
            valueFormatter: (value) =>
                Number(value).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }),
        },
        {
            field: "numeroNota",
            headerName: "Nº Nota",
            flex: 1,
            minWidth: 120,
            // Na API do DataGrid v8 o primeiro argumento já é o valor do campo.
            valueGetter: (value) => (value && typeof value === "object" ? value.numeroNota : value) ?? "-",
        },
        {
            field: "emitidaPor",
            headerName: "Emitida por",
            flex: 1.5,
            minWidth: 160,
            valueGetter: (_, row) =>
                row.emitidaPor === row.idUsuario
                    ? "Cliente"
                    : "Equipe Contblack",
        },
        {
            field: "dataEmissao",
            headerName: "Data de emissão",
            flex: 1.5,
            minWidth: 170,
            valueFormatter: (value) =>
                value
                    ? new Date(value).toLocaleString("pt-BR")
                    : "-",
        },
        {
            field: "acoes",
            headerName: "Ações",
            width: 110,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <Box sx={{ display: "flex", alignItems: "center", height: "100%", gap: 0.5 }}>
                    <Tooltip title={podeBaixarPdf(params.row.status) ? "Baixar PDF" : "PDF disponível após a autorização da nota"}>
                        <span>
                            <IconButton size="small" disabled={!podeBaixarPdf(params.row.status)} onClick={() => handleDownloadNfse(params.row.idNota)}>
                                <DownloadIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>

                    <Tooltip title={podeCancelar(params.row.status) ? "Cancelar nota" : "Somente notas emitidas podem ser canceladas"}>
                        <span>
                            <IconButton
                                size="small"
                                color="error"
                                disabled={!podeCancelar(params.row.status)}
                                onClick={() => {
                                    setIdNotaSelecionadaParaCancelamento(params.row.idNota);
                                    setOpenModalMotivoCancelamento(true);
                                }}
                            >
                                <CancelOutlinedIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>
                </Box>
            ),
        },
    ];

    const [openModalMotivoCancelamento, setOpenModalMotivoCancelamento] = useState(false);

    const [notasEmitidas, setNotasEmitidas] = useState([]);

    const [showContratoSocial, setShowContratoSocial] = useState(false);
    const [contratoSocial, setContratoSocial] = useState(null);

    // Motivos de reprovação digitados, indexados por `${idFichaCadastral}-${tipo}`
    const [motivosRejeicao, setMotivosRejeicao] = useState({});
    const [documentoEmAvaliacao, setDocumentoEmAvaliacao] = useState(null);

    const [fichaCadastral, setFichaCadastral] = useState([]);
    const [socios, setSocios] = useState([]);
    const [userInfo, setUserInfo] = useState({});
    const [certificado, setCertificado] = useState(null);
    const [empresa, setEmpresa] = useState(null);
    const [servicos, setServicos] = useState([]);
    const [hasTomador, setHasTomador] = useState(false);
    const [perfilLoading, setPerfilLoading] = useState(true);
    const [certificadoLoading, setCertificadoLoading] = useState(false);
    const [servicoLoading, setServicoLoading] = useState(false);
    const [empresaLoading, setEmpresaLoading] = useState(false);
    const [notaLoading, setNotaLoading] = useState(false);
    const [limiteNotas, setLimiteNotas] = useState(0);
    const [qtdEmitidas, setQtdEmitidas] = useState(0);
    const token = localStorage.getItem('token');

    const [cnpjEmpresa, setCnpjEmpresa] = useState('');
    const [inscricaoEstadualEmpresa, setInscricaoEstadualEmpresa] = useState('');
    const [inscricaoMunicipalEmpresa, setInscricaoMunicipalEmpresa] = useState('');
    const [razaoSocialEmpresa, setRazaoSocialEmpresa] = useState('');
    const [nomeFantasiaEmpresa, setNomeFantasiaEmpresa] = useState('');
    const [emailEmpresa, setEmailEmpresa] = useState('');
    const [telefoneEmpresa, setTelefoneEmpresa] = useState('');
    const [celularEmpresa, setCelularEmpresa] = useState('');
    const [cepEmpresa, setCepEmpresa] = useState('');
    const [enderecoEmpresa, setEnderecoEmpresa] = useState('');
    const [numeroEmpresa, setNumeroEmpresa] = useState('');
    const [paisEmpresa, setPaisEmpresa] = useState('Brasil');
    const [estadoEmpresa, setEstadoEmpresa] = useState('');
    const [cidadeEmpresa, setCidadeEmpresa] = useState('');
    const [bairroEmpresa, setBairroEmpresa] = useState('');
    const [codigoIbgeEmpresa, setCodigoIbgeEmpresa] = useState('');
    const [regimeTributarioEmpresa, setRegimeTributarioEmpresa] = useState('');
    const [regimeTributarioEspecialEmpresa, setRegimeTributarioEspecialEmpresa] = useState('');
    const [regimeApuracaoTributariaEmpresa, setRegimeApuracaoTributariaEmpresa] = useState('');
    const [dataCompetencia, setDataCompetencia] = useState(new Date());
    const [alqSimplesNacional, setAlqSimplesNacional] = useState(0);
    const [enderecoFiscal, setEnderecoFiscal] = useState(false);

    const [serie, setSerie] = useState('');
    const [nextNumeroNota, setNextNumeroNota] = useState('');

    const [modalOpen, setModalOpen] = useState(false); // Estado para controlar o modal
    const [selectedImage, setSelectedImage] = useState(''); // Estado para armazenar a imagem selecionada
    const [showConfigAvancadaNfse, setShowConfigAvancadaNfse] = useState(false); // Estado para controlar a exibição da configuração avançada da NFS-e

    const [cancelLoading, setCancelLoading] = useState(false); // Estado para controlar o carregamento do cancelamento da NFSe
    const [faturasVencidas, setFaturasVencidas] = useState([]);
    const [recarregarPerfil, setRecarregarPerfil] = useState(0); // força nova busca do perfil (ex.: status das notas)

    // Função para abrir o modal e definir a imagem selecionada
    const openModal = (imageUrl) => {
        setSelectedImage(imageUrl);
        setModalOpen(true);
    };

    // Função para fechar o modal
    const closeModal = () => {
        setModalOpen(false);
        setSelectedImage(''); // Limpar a imagem selecionada
    };

    // Faturas do Asaas vencidas e não pagas deste cliente.
    useEffect(() => {
        const getFaturasVencidas = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/cobrancasADM`, {
                    headers: { Authorization: localStorage.getItem('token') },
                    params: { idUsuario, status: 'OVERDUE', limite: 200 }
                });
                if (response.data.status !== 200) return;
                setFaturasVencidas(response.data.cobrancas || []);
            } catch (error) {
                console.error("Erro ao buscar faturas vencidas:", error);
            }
        };
        getFaturasVencidas();
    }, [idUsuario]);

    useEffect(() => {
        const getInfoUsuario = async () => {
            try {
                const responseUser = await axios.get(`${process.env.REACT_APP_API_URL}/getInfoPerfilUsuario/${idUsuario}`, {
                    headers: {
                        Authorization: localStorage.getItem('token')
                    }
                });

                if (responseUser.data.status !== 200) {
                    notify.error("Erro ao buscar informações do usuário.");
                    return;
                }
                const dados = responseUser.data.dados || {};
                const empresaDados = dados.empresa || {};

                const rows = (dados.notasEmitidasbyUsuario || []).map((nota) => ({
                    id: nota.idNota, // obrigatório para o DataGrid
                    ...nota,
                }));

                setNotasEmitidas(rows);
                setUserInfo(dados.usuario || {});
                setCertificado(dados.certificado || null);
                setEmpresa(dados.empresa || null);
                setServicos(dados.servicos || []);
                if (dados.assinatura) {
                    setLimiteNotas(dados.assinatura?.plano?.qtdNfseMensalClarea ?? 0);
                }
                setQtdEmitidas(dados.notasEmitidasbyClarea ?? 0);

                setCnpjEmpresa(empresaDados.cnpj);
                setEnderecoEmpresa(empresaDados.endereco);
                setInscricaoEstadualEmpresa(empresaDados.inscricaoEstadual);
                setInscricaoMunicipalEmpresa(empresaDados.inscricaoMunicipal);
                setRazaoSocialEmpresa(empresaDados.razaoSocial);
                setNomeFantasiaEmpresa(empresaDados.nomeFantasia);
                setRegimeTributarioEmpresa(empresaDados.taxRegime ?? '');
                setRegimeTributarioEspecialEmpresa(empresaDados.specialTaxRegime ?? '');
                setRegimeApuracaoTributariaEmpresa(empresaDados.simplesNacionalTaxRegime ?? '');
                setCelularEmpresa(empresaDados.celular);
                setCepEmpresa(empresaDados.cep);
                setNumeroEmpresa(empresaDados.numero);
                setEstadoEmpresa(empresaDados.estado);
                setCidadeEmpresa(empresaDados.cidade);
                setBairroEmpresa(empresaDados.bairro);
                setEmailEmpresa(empresaDados.email);
                setTelefoneEmpresa(empresaDados.telefone);
                setCodigoIbgeEmpresa(empresaDados.codigoIbge);

                setSerie(empresaDados.series);
                setNextNumeroNota(empresaDados.nextNumber);
            } catch (error) {
                console.error("Erro ao buscar informações do usuário:", error);
                notify.error("Não foi possível carregar o perfil do usuário.");
            } finally {
                setPerfilLoading(false);
            }
        }

        getInfoUsuario();
    }, [idUsuario, certificadoLoading, servicoLoading, empresaLoading, notaLoading, cancelLoading, recarregarPerfil]);

    const [isDragging, setIsDragging] = useState(false);
    const [file, setFile] = useState(null);
    const [senha, setSenha] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [codigo, setCodigo] = useState("");
    const fileInputRef = useRef(null);

    const [servicoASerAdicionado, setServicoASerAdicionado] = useState({});

    // Funções de drag and drop
    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => setIsDragging(false);

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        if (!empresa) return;
        const droppedFile = e.dataTransfer.files[0];
        validateFile(droppedFile);
    };

    const handleFileSelect = (e) => {
        const selectedFile = e.target.files[0];
        validateFile(selectedFile);
    };

    const validateFile = (file) => {
        const nome = file?.name?.toLowerCase() || "";
        if (file && (nome.endsWith(".pfx") || nome.endsWith(".p12"))) {
            setFile(file);
        } else {
            notify.warning("Por favor, selecione um arquivo .pfx ou .p12 válido.");
        }
    };

    // Controle da visibilidade da senha
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => event.preventDefault();

    const handleSaveUserInfo = () => {
        console.log("Salvar informações do usuário:", userInfo);
    }

    const handleSaveCertificado = async () => {
        if (!file) return notify.warning("Selecione um arquivo de certificado.");
        if (!senha) return notify.warning("Digite a senha do certificado.");

        const formData = new FormData();
        formData.append("arquivo", file);
        formData.append("senha", senha);
        formData.append("email", userInfo.Email);
        formData.append("idUsuario", idUsuario);

        try {
            setCertificadoLoading(true);
            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/uploadCertificadoADM`, formData, {
                headers: {
                    Authorization: token,
                    "Content-Type": "multipart/form-data",
                },
            });
            if (data.status === 200) {
                notify.success("Certificado atualizado com sucesso!");
                setFile(null);
                setSenha("");
            } else {
                notify.error(data.error || "Falha ao atualizar certificado. Verifique os dados e tente novamente.");
            }
        } catch (err) {
            console.error(err);
            notify.error(getErrorMessage(err, "Erro ao enviar o certificado. Tente novamente mais tarde."));
        } finally {
            setCertificadoLoading(false);
        }
    }

    const handleSaveServico = async () => {

        if (!servicoASerAdicionado || !servicoASerAdicionado.code) {
            notify.warning("Selecione um serviço válido para adicionar.");
            return;
        }
        try {
            setServicoLoading(true);
            await axios.post(`${process.env.REACT_APP_API_URL}/adicionarServicoADM`, {
                idUsuario: Number(idUsuario),
                codigo: servicoASerAdicionado.code,
                discriminacao: servicoASerAdicionado.description,
            }, {
                headers: {
                    Authorization: token,
                },
            });
            notify.success("Serviço adicionado.");
        } catch (err) {
            console.error(err);
            notify.error(getErrorMessage(err, "Erro ao adicionar serviço. Tente novamente mais tarde."));
        } finally {
            setServicoLoading(false);
            setServicoASerAdicionado({}); // Limpa o serviço selecionado após a adição
        }

    }

    const [valorServico, setValorServico] = useState('0');
    const [descricaoDoServico, setDescricaoDoServico] = useState('');
    const [deducoes, setDeducoes] = useState('');
    const [valorLiquido, setValorLiquido] = useState('');
    const [baseCalculo, setBaseCalculo] = useState('');

    const [impostoIssAlq, setImpostoIssAlq] = useState('');
    const [impostoIssValor, setImpostoIssValor] = useState('');

    const [impostoPisAlq, setImpostoPisAlq] = useState('');
    const [impostoPisValor, setImpostoPisValor] = useState('');

    const [impostoCofinsAlq, setImpostoCofinsAlq] = useState('');
    const [impostoCofinsValor, setImpostoCofinsValor] = useState('');

    const [impostoCsllAlq, setImpostoCsllAlq] = useState('');
    const [impostoCsllValor, setImpostoCsllValor] = useState('');

    const [impostoIrAlq, setImpostoIrAlq] = useState('');
    const [impostoIrValor, setImpostoIrValor] = useState('');

    const [impostoInssAlq, setImpostoInssAlq] = useState('');
    const [impostoInssValor, setImpostoInssValor] = useState('');

    const [reterIss, setReterIss] = useState(false);
    const [valorIssRetido, setValorIssRetido] = useState('');

    const [reterPis, setReterPis] = useState(false);
    const [valorPisRetido, setValorPisRetido] = useState('');

    const [reterCofins, setReterCofins] = useState(false);
    const [valorCofinsRetido, setValorCofinsRetido] = useState('');

    const [reterCsll, setReterCsll] = useState(false);
    const [valorCsllRetido, setValorCsllRetido] = useState('');

    const [reterIr, setReterIr] = useState(false);
    const [valorIrRetido, setValorIrRetido] = useState('');

    const [reterInss, setReterInss] = useState(false);
    const [valorInssRetido, setValorInssRetido] = useState('');

    const [cpfCnpjTomador, setCpfCnpjTomador] = useState('');
    const [emailTomador, setEmailTomador] = useState('');
    const [cepTomador, setCepTomador] = useState('');
    const [enderecoTomador, setEnderecoTomador] = useState('');
    const [numeroTomador, setNumeroTomador] = useState('');
    const [estadoTomador, setEstadoTomador] = useState('');
    const [cidadeTomador, setCidadeTomador] = useState('');
    const [bairroTomador, setBairroTomador] = useState('');
    const [telefoneTomador, setTelefoneTomador] = useState('');
    const [nomeTomador, setNomeTomador] = useState('');
    const [paisTomador, setPaisTomador] = useState('');
    const [codigoIbgeTomador, setCodigoIbgeTomador] = useState('');



    const handleEmitirNota = async () => {
        const formatarValor = (valor) => {
            return Number(String(valor ?? "").replace("R$ ", "").replace(/\./g, "").replace(",", "."));
        };

        if (bloqueioEmissao) {
            notify.warning(bloqueioEmissao);
            return;
        }

        if (hasTomador && (!nomeTomador?.trim() || !cpfCnpjTomador)) {
            notify.warning('Por favor, informe o nome e o CPF/CNPJ do tomador.');
            return;
        }

        if (!codigo) {
            notify.warning('Por favor, selecione um serviço.');
            return;
        }

        if (!descricaoDoServico?.trim()) {
            notify.warning('Por favor, informe a descrição do serviço.');
            return;
        }

        const valorServicoNumero = formatarValor(valorServico) || 0;
        if (valorServicoNumero <= 0) {
            notify.warning('Por favor, informe um valor de serviço válido.');
            return;
        }

        const valorIrRetidoNumero = reterIr ? (formatarValor(valorIrRetido) || 0) : 0;
        if (reterIr && (valorIrRetidoNumero <= 0 || valorIrRetidoNumero > valorServicoNumero)) {
            notify.warning('Informe um valor de IR retido maior que zero e menor que o valor do serviço.');
            return;
        }

        if (!(dataCompetencia instanceof Date) || Number.isNaN(dataCompetencia.getTime())) {
            notify.warning('Por favor, informe uma data de competência válida.');
            return;
        }

        // calculado aqui para não depender da ordem em que os campos foram preenchidos
        const valorLiquidoNumero = Number((valorServicoNumero - valorIrRetidoNumero).toFixed(2));

        const body = {
            idUsuario: Number(idUsuario),
            dataCompetencia: dataCompetencia.toISOString(),
            tomador: {
                name: hasTomador ? nomeTomador : null,
                federalTaxNumber: hasTomador ? TirarMascara(cpfCnpjTomador) : null,
                email: hasTomador ? emailTomador : null,
                phoneNumber: hasTomador ? TirarMascara(telefoneTomador) : null,
                address: {
                    street: hasTomador ? enderecoTomador : null,
                    district: hasTomador ? bairroTomador : null,
                    postalCode: hasTomador ? TirarMascara(cepTomador) : null,
                    number: hasTomador ? numeroTomador : null,
                    city: {
                        name: hasTomador ? cidadeTomador : null,
                        state: hasTomador ? estadoTomador : null,
                        code: hasTomador ? codigoIbgeTomador : null
                    },
                    country: hasTomador ? "BRA" : null
                }
            },
            total: {
                valorServico: valorServicoNumero,
                valorLiquido: valorLiquidoNumero,
                alqIss: impostoIssAlq ? formatarValor(impostoIssAlq) : 0,
                valorIss: impostoIssValor ? formatarValor(impostoIssValor) : 0,
                alqPis: impostoPisAlq ? formatarValor(impostoPisAlq) : 0,
                valorPis: impostoPisValor ? formatarValor(impostoPisValor) : 0,
                alqCofins: impostoCofinsAlq ? formatarValor(impostoCofinsAlq) : 0,
                valorCofins: impostoCofinsValor ? formatarValor(impostoCofinsValor) : 0,
                alqCsll: impostoCsllAlq ? formatarValor(impostoCsllAlq) : 0,
                valorCsll: impostoCsllValor ? formatarValor(impostoCsllValor) : 0,
                alqIr: impostoIrAlq ? formatarValor(impostoIrAlq) : 0,
                valorIr: impostoIrValor ? formatarValor(impostoIrValor) : 0,
                alqInss: impostoInssAlq ? formatarValor(impostoInssAlq) : 0,
                valorInss: impostoInssValor ? formatarValor(impostoInssValor) : 0,
                reterIss,
                valorIssRetido: valorIssRetido ? formatarValor(valorIssRetido) : 0,
                reterPis,
                valorPisRetido: valorPisRetido ? formatarValor(valorPisRetido) : 0,
                reterCofins,
                valorCofinsRetido: valorCofinsRetido ? formatarValor(valorCofinsRetido) : 0,
                reterCsll,
                valorCsllRetido: valorCsllRetido ? formatarValor(valorCsllRetido) : 0,
                reterIr,
                valorIrRetido: valorIrRetidoNumero,
                reterInss,
                valorInssRetido: valorInssRetido ? formatarValor(valorInssRetido) : 0,
            },
            approximateTaxes: {
                simplesNacionalRate: alqSimplesNacional ? formatarValor(alqSimplesNacional) : 0,
                mode: "simplified"
            },
            descricaoDoServico,
            codigo,
            hasTomador
        };
        try {
            setNotaLoading(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/emitirNotaServicoADM`, body, {
                headers: {
                    Authorization: localStorage.getItem('token'),
                    'Content-Type': 'application/json'
                }
            });
            if (response.data.status === 200) {
                // a emissão é assíncrona: o status muda para Emitida/Rejeitada quando a prefeitura responder
                notify.success('Nota enviada para emissão. Acompanhe o status na lista de notas abaixo.');
                setCodigo('');
                setDescricaoDoServico('');
                setValorServico('');
                setValorLiquido('');
                setBaseCalculo('');
                setReterIr(false);
                setValorIrRetido('');
                setAlqSimplesNacional('');
            } else {
                const detalhe = typeof response.data === 'string' ? response.data : (response.data?.message || response.data?.error || '');
                notify.error(detalhe || 'Verifique os dados e tente novamente.', { title: 'Erro ao emitir nota fiscal' });
            }
        } catch (error) {
            console.error("Erro ao emitir nota fiscal:", error);
            notify.error(getErrorMessage(error, 'Verifique os dados e tente novamente.'), { title: 'Erro ao emitir nota fiscal' });
        } finally {
            setNotaLoading(false);
        }
    }

    const handleCepTomador = async (e) => {
        let value = TirarMascara(e.target.value.slice(0, 9));
        setCepTomador(value);
        if (value.length === 8) {
            try {
                const response = await axios.get(`https://viacep.com.br/ws/${value}/json/`);
                if (response.data?.erro) throw new Error("CEP não encontrado");
                setEnderecoTomador(response.data.logradouro || '');
                setCidadeTomador(response.data.localidade || '');
                setEstadoTomador((response.data.uf || '').toLowerCase());
                setBairroTomador(response.data.bairro || '');
                setCodigoIbgeTomador(response.data.ibge || '');
                setPaisTomador('Brasil'); // Definindo o país como Brasil
            } catch (error) {
                setEnderecoTomador('');
                setCidadeTomador('');
                setEstadoTomador('');
                setBairroTomador('');
                setCodigoIbgeTomador('');
                setPaisTomador('');
                notify.error("Não encontramos o endereço deste CEP. Verifique se o CEP é válido.");
                console.error("Erro ao buscar endereço:", error);
            }
        }
    }

    const handleCepChange = async (e) => {
        let value = TirarMascara(e.target.value);
        setCepEmpresa(value);
        if (value.length === 8) {
            try {
                const response = await axios.get(`https://viacep.com.br/ws/${value}/json/`);
                if (response.data?.erro) throw new Error("CEP não encontrado");
                setEnderecoEmpresa(response.data.logradouro || '');
                setCidadeEmpresa(response.data.localidade || '');
                setEstadoEmpresa((response.data.uf || '').toLowerCase());
                setBairroEmpresa(response.data.bairro || '');
                setCodigoIbgeEmpresa(response.data.ibge || '');
            } catch (error) {
                notify.error("Não encontramos o endereço deste CEP. Verifique se o CEP é válido.");
                console.error("Erro ao buscar endereço:", error);
            }
        }
    }

    const handleSaveCompanyConfig = async () => {
        if (!serie) {
            notify.warning("Série é obrigatória.");
            return;
        }

        if (!nextNumeroNota) {
            notify.warning("Número do próximo RPS/DPS ou NFS-e é obrigatório.");
            return;
        }

        const body = {
            idUsuario,
            serie,
            nextNumeroNota,
        };

        try {
            setEmpresaLoading(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/salvarConfiguracoesEmpresaADM`, body, {
                headers: {
                    Authorization: token,
                    'Content-Type': 'application/json'
                }
            });
            if (response.data.status === 200) {
                notify.success("Configurações da empresa atualizadas com sucesso!");
            } else {
                notify.error(response.data.message || response.data.erro || response.data.error ||"Verifique os dados e tente novamente.", { title: "Erro ao atualizar configurações da empresa" });
            }
        } catch (error) {
            console.error("Erro ao atualizar configurações da empresa:", error);
            notify.error(getErrorMessage(error, "Não foi possível atualizar as configurações da empresa. Tente novamente mais tarde."));
        } finally {
            setEmpresaLoading(false);
        }
    }

    const handleSaveCompany = async () => {
        const obrigatorios = [
            [!nomeFantasiaEmpresa, "Nome Fantasia é obrigatório."],
            [!razaoSocialEmpresa, "Razão Social é obrigatória."],
            [cnpjEmpresa?.length !== 14, "CNPJ inválido."],
            [!enderecoEmpresa, "Endereço é obrigatório."],
            [!bairroEmpresa, "Bairro é obrigatório."],
            [cepEmpresa?.length !== 8, "CEP inválido."],
            [!estadoEmpresa, "Estado é obrigatório."],
            [!cidadeEmpresa, "Cidade é obrigatória."],
            [!numeroEmpresa, "Número do endereço é obrigatório."],
        ];

        const erro = obrigatorios.find(([invalido]) => invalido);
        if (erro) {
            notify.warning(erro[1]);
            return;
        }

        const body = {
            idUsuario,
            nomeFantasiaEmpresa,
            razaoSocialEmpresa,
            cnpjEmpresa,
            inscricaoEstadualEmpresa,
            inscricaoMunicipalEmpresa,
            emailEmpresa,
            telefoneEmpresa,
            celularEmpresa,
            endereco: {
                enderecoEmpresa,
                bairroEmpresa,
                cepEmpresa,
                numeroEmpresa,
            },
            cidade: {
                codigoIbge: codigoIbgeEmpresa,
                nome: cidadeEmpresa,
                state: estadoEmpresa,
            },
            pais: {
                nome: paisEmpresa,
            },
            taxRegime: regimeTributarioEmpresa,
            specialTaxRegime: regimeTributarioEspecialEmpresa,
            simplesNacionalTaxRegime: regimeApuracaoTributariaEmpresa,
        };

        try {
            setEmpresaLoading(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/salvarDadosEmpresaADM`, body, {
                headers: {
                    Authorization: token,
                    'Content-Type': 'application/json'
                }
            });
            if (response.data.status === 200) {
                notify.success("Informações da empresa atualizadas com sucesso!");
            } else {
                notify.error(response.data.message || response.data.erro || response.data.error ||"Verifique os dados e tente novamente.", { title: "Erro ao atualizar informações da empresa" });
            }
        } catch (error) {
            console.error("Erro ao atualizar informações da empresa:", error);
            notify.error(getErrorMessage(error, "Não foi possível atualizar as informações da empresa. Tente novamente mais tarde."));
        } finally {
            setEmpresaLoading(false);
        }
    }

    const handleCnpjTomador = async (e) => {
        let value = e.target.value;
        if (!value) {
            setCpfCnpjTomador('');
            return;
        }

        const somenteNumeros = value.replace(/\D/g, "");

        // CPF até 11 dígitos | CNPJ até 14 dígitos
        if (somenteNumeros.length <= 11) {
            setCpfCnpjTomador(MascaraCpf(value));
            return;
        }

        // Caso seja CNPJ
        setCpfCnpjTomador(MascaraCnpj(value));
    };

    useEffect(() => {
        const getFichaCadastral = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/getFichaCadastralADM/${idUsuario}`, {
                headers: {
                    Authorization: token
                }
            });

            // A API retorna uma lista de fichas; cada item pode vir como { ficha: {...} } ou já como a própria ficha
            const listaFichas = Array.isArray(response.data.ficha)
                ? response.data.ficha
                : response.data.ficha ? [response.data.ficha] : [];
            setFichaCadastral(listaFichas.map((item) => item?.ficha ?? item).filter(Boolean));
        }

        getFichaCadastral().catch((error) => {
            console.error("Erro ao buscar ficha cadastral:", error);
        });
    }, [idUsuario, token]);

    // Sócios e seus documentos: [{ idFichaCadastral, idDocumento, nome, cpf, percentual, documentos: [...] }]
    const getDocumentosSocios = useCallback(async () => {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/getDocumentosUsuarioADM/${idUsuario}`, {
            headers: {
                Authorization: token
            }
        });
        setSocios(Array.isArray(response.data.socios) ? response.data.socios : []);
    }, [idUsuario, token]);

    useEffect(() => {
        getDocumentosSocios().catch((error) => {
            console.error("Erro ao buscar documentos dos sócios:", error);
        });
    }, [getDocumentosSocios]);

    useEffect(() => {
        const getAssinaturaEnderecoFiscal = () => {
            axios.get(`${process.env.REACT_APP_API_URL}/getAssinaturaEnderecoFiscalADM/${idUsuario}`, {
                headers: {
                    Authorization: token
                }
            }).then((response) => {
                setEnderecoFiscal(response.data.hasAssinaturaEnderecoFiscal);
            }).catch((error) => {
                console.error("Erro ao buscar assinatura e endereço fiscal:", error);
            });
        }
        getAssinaturaEnderecoFiscal();
    }, [idUsuario, token]);

    const chaveDocumento = (socio, documento) => `${socio.idFichaCadastral}-${documento.tipo}`;

    const handleMotivoRejeicaoChange = (socio, documento, valor) => {
        const chave = chaveDocumento(socio, documento);
        setMotivosRejeicao((prev) => ({ ...prev, [chave]: valor }));
    };

    // acao: "aceitar" | "rejeitar"
    const handleAvaliarDoc = async (acao, socio, documento) => {
        const chave = chaveDocumento(socio, documento);
        const motivo = (motivosRejeicao[chave] ?? "").trim();

        if (acao === "rejeitar" && !motivo) {
            notify.warning("Informe o motivo da reprovação.");
            return;
        }

        const rota = acao === "rejeitar" ? "rejeitarDocumentoADM" : "aceitarDocumentoADM";

        setDocumentoEmAvaliacao(chave);
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/${rota}/${documento.tipo}`, {
                idUsuario: Number(idUsuario),
                idFichaCadastral: socio.idFichaCadastral,
                idDocumento: socio.idDocumento,
                motivoRejeicao: acao === "rejeitar" ? motivo : null
            }, {
                headers: {
                    Authorization: token
                }
            });

            setMotivosRejeicao((prev) => {
                const { [chave]: _, ...resto } = prev;
                return resto;
            });
            notify.success(acao === "rejeitar" ? "Documento reprovado." : "Documento aprovado.");
            await getDocumentosSocios();
        } catch (error) {
            console.error(`Erro ao ${acao} documento:`, error);
            notify.error(`Erro ao ${acao === "rejeitar" ? "reprovar" : "aceitar"} o documento. Tente novamente.`);
        } finally {
            setDocumentoEmAvaliacao(null);
        }
    };

    const todosDocumentosSocios = socios.flatMap((socio) => socio?.documentos ?? []);
    const documentosAprovados = todosDocumentosSocios.filter((doc) => doc?.status === "Aprovado").length;
    const documentosEmAnalise = todosDocumentosSocios.filter((doc) => doc?.status === "Em Análise").length;
    const contratoSocialEnviado = todosDocumentosSocios.some((doc) => doc?.tipo === "contratoSocial" && doc?.url);
    const fichasCompletas = fichaCadastral.filter((ficha) => ficha?.progress === 100).length;

    const handleDeleteService = async (servico) => {
        const confirmado = await confirmDialog({
            title: "Remover serviço",
            message: `Deseja remover o serviço ${formatarCodigoServico(servico.codigo)} - ${servico.discriminacao} deste cliente?`,
            confirmText: "Remover",
            destructive: true,
        });
        if (!confirmado) return;

        try {
            setServicoLoading(true);
            const response = await axios.delete(
                `${process.env.REACT_APP_API_URL}/deletarServicoADM`,
                {
                    headers: {
                        authorization: token,
                    },
                    data: {
                        idServico: servico.idServico,
                    },
                }
            );
            if (response.data.status === 200) {
                notify.success("Serviço removido.");
            } else {
                console.error("Erro ao deletar serviço:", response.data);
                notify.error("Falha ao deletar serviço. Tente novamente.");
            }
        } catch (err) {
            console.error(err);
            notify.error("Erro ao deletar serviço. Tente novamente mais tarde.");
        } finally {
            setServicoLoading(false);
        }
    }

    const [contratoLoading, setContratoLoading] = useState(false);

    const enviarContratoSocial = async () => {
        try {
            if (!contratoSocial) {
                notify.warning("Selecione um arquivo antes de enviar.");
                return;
            }

            const formData = new FormData();

            formData.append("contratoSocial", contratoSocial);
            formData.append("userId", Number(idUsuario));

            setContratoLoading(true);
            await axios.post(`${process.env.REACT_APP_API_URL}/contrato-social/upload`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": token,
                },
            });

            notify.success("Contrato enviado com sucesso!");
            setShowContratoSocial(false);
            setContratoSocial(null);
            getDocumentosSocios().catch(() => { });
        } catch (error) {
            console.error(error);
            notify.error(getErrorMessage(error, "Erro ao enviar o contrato social."));
        } finally {
            setContratoLoading(false);
        }
    };

    const handleDeducoesChange = (e) => {
        const value = e.target.value;

        const parseCurrency = (valor) => {
            if (!valor) return 0;

            return Number(
                valor
                    .replace("R$ ", "")
                    .replace(/\./g, "")
                    .replace(",", ".")
            );
        };

        const valorServicoNumber = parseCurrency(valorServico);
        let deducoesNumber = parseCurrency(value);

        // Não permite dedução maior que o valor do serviço
        if (deducoesNumber > valorServicoNumber) {
            notify.warning("Deduções não podem ser maiores que o valor do serviço.");
            deducoesNumber = 0;
        }

        const baseCalculoNumber = Math.max(
            valorServicoNumber - deducoesNumber,
            0
        );

        setDeducoes(
            deducoesNumber.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
            })
        );

        setBaseCalculo(
            baseCalculoNumber.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
            })
        );

        setValorLiquido(
            (valorServicoNumber).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
            })
        );
        setImpostoIssValor('');
        setImpostoIssAlq('');

        setImpostoPisValor('');
        setImpostoPisAlq('');

        setImpostoCofinsAlq('');
        setImpostoCofinsValor('');

        setImpostoCsllAlq('');
        setImpostoCsllValor('');

        setImpostoIrAlq('');
        setImpostoIrValor('');

        setImpostoInssAlq('');
        setImpostoInssValor('');
    };

    const handleShowInformation = () => {
        setShowConfigAvancadaNfse(!showConfigAvancadaNfse)

        setImpostoIssAlq('');
        setImpostoIssValor('');

        setImpostoPisAlq('');
        setImpostoPisValor('');

        setImpostoCofinsAlq('');
        setImpostoCofinsValor('');

        setImpostoCsllAlq('');
        setImpostoCsllValor('');

        setImpostoIrAlq('');
        setImpostoIrValor('');

        setImpostoInssAlq('');
        setImpostoInssValor('');

        setReterIss(false);
        setValorIssRetido('');

        setReterPis(false);
        setValorPisRetido('');

        setReterCofins(false);
        setValorCofinsRetido('');

        setReterCsll(false);
        setValorCsllRetido('');

        setReterIr(false);
        setValorIrRetido('');

        setReterInss(false);
        setValorInssRetido('');

    }

    const handleIrChange = (e) => {

        const moedaParaNumero = (valor = "") => {
            return Number(
                valor
                    .toString()
                    .replace("R$", "")
                    .replace(/\s/g, "")
                    .replace(/\./g, "")
                    .replace(",", ".")
            ) || 0;
        };

        setValorIrRetido(e.target.value);
        setValorLiquido((moedaParaNumero(baseCalculo) - moedaParaNumero(e.target.value)).toFixed(2).replace('.', ','));
    }

    const handleCancelNfse = async (idNota, reason) => {
        try {
            setCancelLoading(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/cancelar/nfse`, {
                idNota,
                reason,
            }, {
                headers: {
                    Authorization: token,
                },
            });

            if (response.data?.status && response.data.status !== 200) {
                notify.error(response.data.message || response.data.erro || response.data.error ||"A nota não pôde ser cancelada.", { title: "Erro ao cancelar NFS-e" });
            } else {
                notify.success("Solicitação de cancelamento enviada.");
            }
        } catch (error) {
            console.error("Erro ao cancelar NFSe:", error);
            notify.error(getErrorMessage(error, "Erro ao cancelar NFS-e. Tente novamente mais tarde."));
        } finally {
            setCancelLoading(false);
        }
    }

    const handleDownloadNfse = async (idNota) => {

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/download/nfse/pdf`, {
                idNota: idNota,
            }, {
                headers: {
                    Authorization: token,
                },
                responseType: "blob",
            });

            const blob = new Blob([response.data], {
                type: "application/pdf",
            });

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = `nota_${idNota}.pdf`;
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Erro ao baixar NFSe:", error);
            notify.error("Erro ao baixar NFS-e. Tente novamente mais tarde.");
        }
    }

    const [transacoesUsuario, setTransacoesUsuario] = useState([]);

    const [dataInicial, setDataInicial] = useState('');
    const [dataFinal, setDataFinal] = useState('');
    const [loadingTransacoes, setLoadingTransacoes] = useState(false);
    const [buscouTransacoes, setBuscouTransacoes] = useState(false);

    const handleFindTransactions = async () => {
        if (dataInicial && dataFinal && new Date(dataInicial) > new Date(dataFinal)) {
            notify.warning("A data inicial deve ser anterior à data final.");
            return;
        }
        try {
            setLoadingTransacoes(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/getTransacoesUsuarioADM`,
                {
                    idUsuario,
                    dataInicial,
                    dataFinal,
                },
                {
                    headers: {
                        Authorization: token
                    }
                }
            );
            setTransacoesUsuario(response.data.transacoesPorBanco || []);
            setPaginas({});
        } catch (error) {
            console.error("Erro ao buscar transações:", error);
            notify.error("Não foi possível buscar as movimentações bancárias.");
        } finally {
            setLoadingTransacoes(false);
            setBuscouTransacoes(true);
        }
    }


    const [paginas, setPaginas] = useState({});
    const [linhasPorPagina, setLinhasPorPagina] = useState(10);


    const handleChangePagina = (indexBanco, novaPagina) => {
        setPaginas((prev) => ({
            ...prev,
            [indexBanco]: novaPagina
        }));
    };
    const handleChangeLinhasPorPagina = (event) => {
        setLinhasPorPagina(parseInt(event.target.value, 10));

        setPaginas({});
    };

    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const certificadoVencido = !!certificado?.dataExpiracao && new Date(certificado.dataExpiracao) < new Date();
    const statusCertificado = !certificado ? "Não enviado" : certificadoVencido ? "Vencido" : certificado?.ativo ? "Ativo" : "Inativo";
    const toneCertificado = !certificado || certificadoVencido ? "error" : certificado?.ativo ? "success" : "warning";

    // Motivo que impede a emissão (empresa sem cadastro na Spedy, certificado, limite da equipe)
    const bloqueioEmissao =
        perfilLoading ? null :
            !empresa ? 'Cadastre a empresa do cliente na aba "Empresa e certificado" antes de emitir notas.' :
                !empresa.emissaoConfigurada ? 'A empresa não está cadastrada na Spedy. Salve novamente os dados da empresa na aba "Empresa e certificado".' :
                    !certificado ? 'Envie o certificado digital do cliente na aba "Empresa e certificado" antes de emitir notas.' :
                        certificadoVencido ? 'O certificado digital do cliente está vencido. Envie o certificado renovado antes de emitir notas.' :
                            limiteNotas !== -1 && qtdEmitidas >= limiteNotas ? 'O limite mensal de notas emitidas pela equipe para este cliente foi atingido.' :
                                null;

    // ---------- Resumo de status (topo da página) ----------
    const resumoStatus = [
        {
            label: "Certificado digital",
            value: statusCertificado,
            tone: toneCertificado,
        },
        {
            label: "Ficha cadastral",
            value: fichaCadastral.length === 0 ? "Não preenchida" : `${fichasCompletas}/${fichaCadastral.length} completa(s)`,
            tone: fichaCadastral.length > 0 && fichasCompletas === fichaCadastral.length ? "success" : "warning",
        },
        {
            label: "Documentos dos sócios",
            value: todosDocumentosSocios.length === 0 ? "Nenhum" : `${documentosAprovados}/${todosDocumentosSocios.length} aprovado(s)`,
            tone: todosDocumentosSocios.length > 0 && documentosAprovados === todosDocumentosSocios.length ? "success" : documentosEmAnalise > 0 ? "info" : "warning",
        },
        {
            label: "Contrato social",
            value: contratoSocialEnviado ? "Enviado" : "Não enviado",
            tone: contratoSocialEnviado ? "success" : "error",
        },
        {
            label: "Endereço fiscal",
            value: enderecoFiscal ? "Contratado" : "Não contratado",
            tone: enderecoFiscal ? "success" : "neutral",
        },
        {
            label: "NFS-e pela equipe (mês)",
            value: `${qtdEmitidas}/${limiteNotas === -1 ? "ilimitado" : limiteNotas}`,
            tone: limiteNotas !== -1 && qtdEmitidas >= limiteNotas ? "error" : "neutral",
        },
    ];

    const subtituloPerfil = [
        userInfo?.Email,
        userInfo?.Cpf ? `CPF ${MascaraCpf(userInfo.Cpf)}` : null,
        cnpjEmpresa ? `CNPJ ${MascaraCnpj(cnpjEmpresa)}` : null,
    ].filter(Boolean).join(" · ");

    // ---------- Abas ----------
    const abaEmissao = (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {bloqueioEmissao && (
                <Alert severity="warning" variant="outlined" sx={{ bgcolor: "background.paper" }}>
                    {bloqueioEmissao}
                </Alert>
            )}

            <SectionCard
                title="Emitir nota fiscal de serviço"
                description="Preencha os dados abaixo para emitir a NFS-e em nome do cliente."
                status={
                    <StatusChip
                        label={`Limite da equipe: ${qtdEmitidas}/${limiteNotas === -1 ? "ilimitado" : limiteNotas}`}
                        tone={limiteNotas !== -1 && qtdEmitidas >= limiteNotas ? "error" : "neutral"}
                    />
                }
                footer={
                    <Button variant="contained" loading={notaLoading} disabled={!!bloqueioEmissao} onClick={handleEmitirNota}>
                        Emitir nota fiscal
                    </Button>
                }
            >
                <SubTitulo description="Dados da empresa emissora, preenchidos a partir do cadastro.">Prestador</SubTitulo>
                <FieldGrid>
                    <TextField size="small" label="CPF ou CNPJ" disabled value={MascaraCnpj(cnpjEmpresa)} />
                    <TextField size="small" label="Razão Social" disabled value={razaoSocialEmpresa || ''} />
                </FieldGrid>

                <Divider sx={{ my: 3 }} />

                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1, mb: hasTomador ? 2 : 0 }}>
                    <Box>
                        <Typography variant="subtitle1">Tomador</Typography>
                        <Typography variant="body2" color="text.secondary">
                            {hasTomador ? "Preencha os dados do tomador do serviço." : "Nota fiscal de serviço sem tomador identificado."}
                        </Typography>
                    </Box>
                    <FormControlLabel
                        control={<Checkbox size="small" checked={hasTomador} onChange={(e) => setHasTomador(e.target.checked)} />}
                        label={<Typography variant="body2">Nota possui tomador</Typography>}
                    />
                </Box>
                <Collapse in={hasTomador}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <FieldGrid>
                            <TextField size="small" label="Nome" required value={nomeTomador} onChange={e => setNomeTomador(e.target.value)} />
                            <TextField size="small" label="CPF ou CNPJ" required value={cpfCnpjTomador} onChange={e => handleCnpjTomador(e)} />
                        </FieldGrid>
                        <FieldGrid>
                            <TextField size="small" label="E-mail" value={emailTomador} onChange={e => setEmailTomador(e.target.value)} />
                            <TextField size="small" label="Telefone" value={telefoneTomador} onChange={e => setTelefoneTomador(e.target.value)} />
                        </FieldGrid>
                        <FieldGrid cols="1fr 2fr 120px">
                            <TextField size="small" label="CEP" value={MascaraCep(cepTomador)} onChange={e => handleCepTomador(e)} placeholder="00000-000" />
                            <TextField disabled size="small" label="Endereço" value={enderecoTomador} onChange={e => setEnderecoTomador(e.target.value)} />
                            <TextField size="small" label="Número" value={numeroTomador} onChange={e => setNumeroTomador(e.target.value)} />
                        </FieldGrid>
                        <FieldGrid cols="repeat(4, 1fr)">
                            <TextField disabled size="small" label="País" value={paisTomador} onChange={e => setPaisTomador(e.target.value)} />
                            <TextField disabled size="small" label="Estado" value={estadoTomador} onChange={e => setEstadoTomador(e.target.value)} />
                            <TextField disabled size="small" label="Cidade" value={cidadeTomador} onChange={e => setCidadeTomador(e.target.value)} />
                            <TextField disabled size="small" label="Bairro" value={bairroTomador} onChange={e => setBairroTomador(e.target.value)} />
                        </FieldGrid>
                    </Box>
                </Collapse>

                <Divider sx={{ my: 3 }} />

                <SubTitulo description="Somente os serviços cadastrados para o cliente aparecem na lista.">Serviço</SubTitulo>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <FormControl size="small" fullWidth>
                        <InputLabel id="servico-nota-label">Serviço</InputLabel>
                        <Select
                            labelId="servico-nota-label"
                            value={codigo}
                            label="Serviço"
                            onChange={e => setCodigo(e.target.value)}
                        >
                            {servicos.length === 0 && (
                                <MenuItem value="" disabled>Nenhum serviço cadastrado para este cliente</MenuItem>
                            )}
                            {servicos.map(servico => (
                                <MenuItem key={servico.idServico ?? servico.codigo} value={servico.codigo}>
                                    {formatarCodigoServico(servico.codigo)} - {servico.discriminacao}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField size="small" multiline minRows={2} label="Descrição do serviço" fullWidth value={descricaoDoServico} onChange={e => setDescricaoDoServico(e.target.value)} />
                    <FieldGrid>
                        <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} size="small" label="Valor do serviço" value={valorServico} onChange={e => { setValorServico(e.target.value); setBaseCalculo(e.target.value); setValorLiquido(e.target.value); }} />
                        <TextField
                            size="small"
                            label="Alíquota Simples Nacional / mês"
                            value={alqSimplesNacional}
                            slotProps={{ input: { endAdornment: <InputAdornment position="end">%</InputAdornment> } }}
                            onChange={e => {
                                // permitir apenas numeros e virgula
                                const value = e.target.value.replace(/[^0-9,]/g, '').trim();
                                setAlqSimplesNacional(value);
                            }}
                        />
                    </FieldGrid>
                </Box>

                <Box
                    component="button"
                    type="button"
                    onClick={() => handleShowInformation()}
                    sx={{
                        mt: 3,
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.5,
                        cursor: "pointer",
                        color: "text.primary",
                        background: "none",
                        border: 0,
                        p: 0,
                        font: "inherit",
                        "&:hover": { color: "secondary.main" },
                    }}
                >
                    {showConfigAvancadaNfse ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                    <Typography variant="body2" fontWeight={600}>
                        {showConfigAvancadaNfse
                            ? "Ocultar configurações avançadas"
                            : "Exibir configurações avançadas"}
                    </Typography>
                </Box>

                <Collapse in={showConfigAvancadaNfse}>
                    <Box sx={{ mt: 2, p: 2.5, border: "1px solid", borderColor: "divider", borderRadius: 2, bgcolor: "#FCFCFD" }}>
                        <Typography variant="subtitle2" sx={{ mb: 2 }}>
                            Informações da nota
                        </Typography>

                        <FieldGrid cols="repeat(4, 1fr)">
                            <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                                adapterLocale={ptBR}
                            >
                                <DatePicker
                                    label="Data de competência"
                                    value={dataCompetencia}
                                    onChange={(newValue) => setDataCompetencia(newValue)}
                                    format="dd/MM/yyyy"
                                    slotProps={{
                                        textField: {
                                            size: "small",
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                            <NumericFormat disabled customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} size="small" label="Deduções (R$)" value={deducoes} onChange={(e) => handleDeducoesChange(e)} />
                            <TextField disabled size="small" label="Base de cálculo (R$)" value={baseCalculo} />
                            <TextField disabled size="small" label="Valor líquido (R$)" value={valorLiquido} />
                        </FieldGrid>

                        <TextField
                            fullWidth
                            multiline
                            rows={3}
                            size="small"
                            sx={{ mt: 2 }}
                            label="Informações complementares"
                            placeholder="Digite observações que deverão constar na NFS-e..."
                            helperText="Atenção: este campo ainda não é enviado na emissão da nota."
                        />

                        <Typography variant="subtitle2" sx={{ mt: 3, mb: 1.5 }}>
                            Retenções
                        </Typography>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                            {/* IR (demais retenções — ISS, PIS, COFINS, CSLL, INSS — estão desativadas no momento) */}
                            <Box sx={{ flex: "1 1 240px", maxWidth: 280, border: "1px solid", borderColor: "divider", borderRadius: 2, p: 2, bgcolor: "background.paper" }}>
                                <FormControl fullWidth>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1.5 }}>
                                        <FormLabel sx={{ fontWeight: 600, fontSize: "0.8125rem", color: "text.primary" }}>
                                            Reter IR
                                        </FormLabel>
                                        <Switch size="small" color="secondary" onChange={(e) => { setReterIr(e.target.checked); setValorIrRetido(''); }} checked={reterIr} />
                                    </Box>
                                    <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} fullWidth size="small" label="Valor retido" value={valorIrRetido} onChange={e => handleIrChange(e)} disabled={!reterIr} />
                                </FormControl>
                            </Box>
                        </Box>
                    </Box>
                </Collapse>
            </SectionCard>

            <SectionCard
                title="Notas fiscais emitidas"
                description="Histórico de NFS-e emitidas para este cliente."
                actions={
                    <>
                        <Button variant="outlined" size="small" onClick={() => setRecarregarPerfil((n) => n + 1)}>Atualizar status</Button>
                        <Tooltip title="Em desenvolvimento">
                            <span><Button variant="outlined" size="small" disabled>Baixar PDFs</Button></span>
                        </Tooltip>
                        <Tooltip title="Em desenvolvimento">
                            <span><Button variant="outlined" size="small" disabled>Baixar XMLs</Button></span>
                        </Tooltip>
                    </>
                }
            >
                <DataGrid
                    rows={notasEmitidas}
                    columns={columns}
                    loading={perfilLoading}
                    autoHeight
                    pageSizeOptions={[10, 25, 50]}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                                page: 0,
                            },
                        },
                    }}
                    disableRowSelectionOnClick
                    localeText={{ noRowsLabel: "Nenhuma nota emitida." }}
                />
            </SectionCard>
        </Box>
    );

    const abaEmpresa = (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <SectionCard
                title="Informações da empresa"
                description="Dados cadastrais usados na emissão das notas."
                footer={<Button variant="contained" onClick={handleSaveCompany} loading={empresaLoading}>Salvar alterações</Button>}
            >
                {empresa && !empresa.emissaoConfigurada && (
                    <Alert severity="warning" variant="outlined" sx={{ mb: 2 }}>
                        Esta empresa ainda não está cadastrada na Spedy, então não pode emitir notas. Confira os dados e clique em "Salvar alterações" para concluir o cadastro.
                    </Alert>
                )}
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <FieldGrid cols="repeat(3, 1fr)">
                        <TextField size="small" label="CNPJ" value={MascaraCnpj(cnpjEmpresa)} onChange={(e) => setCnpjEmpresa(TirarMascara(e.target.value))} slotProps={{ htmlInput: { maxLength: 18 } }} />
                        <TextField size="small" label="Inscrição Estadual" value={inscricaoEstadualEmpresa || ''} onChange={e => setInscricaoEstadualEmpresa(TirarMascara(e.target.value))} />
                        <TextField size="small" label="Inscrição Municipal" value={inscricaoMunicipalEmpresa || ''} onChange={e => setInscricaoMunicipalEmpresa(TirarMascara(e.target.value))} />
                    </FieldGrid>
                    <FieldGrid>
                        <TextField size="small" label="Razão Social" value={razaoSocialEmpresa || ''} onChange={e => setRazaoSocialEmpresa(e.target.value)} />
                        <TextField size="small" label="Nome Fantasia" value={nomeFantasiaEmpresa || ''} onChange={e => setNomeFantasiaEmpresa(e.target.value)} />
                    </FieldGrid>
                    <FieldGrid cols="2fr 1fr 1fr">
                        <TextField size="small" label="E-mail" value={emailEmpresa || ''} onChange={e => setEmailEmpresa(e.target.value)} />
                        <TextField size="small" label="Telefone" value={MascaraTelefone(telefoneEmpresa)} onChange={e => setTelefoneEmpresa(TirarMascara(e.target.value))} slotProps={{ htmlInput: { maxLength: 14 } }} />
                        <TextField size="small" label="Celular" value={MascaraCelular(celularEmpresa)} onChange={e => setCelularEmpresa(TirarMascara(e.target.value))} slotProps={{ htmlInput: { maxLength: 15 } }} />
                    </FieldGrid>
                    <FieldGrid cols="1fr 3fr 120px">
                        <TextField size="small" label="CEP" value={MascaraCep(cepEmpresa)} onChange={e => handleCepChange(e)} slotProps={{ htmlInput: { maxLength: 9 } }} placeholder="00000-000" />
                        <TextField size="small" label="Endereço" disabled value={enderecoEmpresa || ''} onChange={e => setEnderecoEmpresa(e.target.value)} />
                        <TextField size="small" label="Número" value={numeroEmpresa || ''} onChange={e => setNumeroEmpresa(e.target.value)} />
                    </FieldGrid>
                    <FieldGrid cols="repeat(4, 1fr)">
                        <TextField size="small" label="País" disabled value={paisEmpresa} onChange={e => setPaisEmpresa(e.target.value)} />
                        <TextField size="small" label="Estado" disabled value={estadoEmpresa || ''} onChange={e => setEstadoEmpresa(e.target.value)} />
                        <TextField size="small" label="Cidade" disabled value={cidadeEmpresa || ''} onChange={e => setCidadeEmpresa(e.target.value)} />
                        <TextField size="small" label="Bairro" disabled value={bairroEmpresa || ''} onChange={e => setBairroEmpresa(e.target.value)} />
                    </FieldGrid>

                    <Divider sx={{ my: 1 }} />
                    <Typography variant="subtitle2">Regime tributário</Typography>

                    <FieldGrid cols="1fr 1fr">
                        <FormControl size="small">
                            <InputLabel id="regime-tributario-label">Regime tributário</InputLabel>
                            <Select
                                labelId="regime-tributario-label"
                                value={regimeTributarioEmpresa}
                                label="Regime tributário"
                                onChange={e => setRegimeTributarioEmpresa(e.target.value)}
                            >
                                <MenuItem value={"simplesNacional"}>Simples Nacional</MenuItem>
                                <MenuItem value={"simplesNacionalExcessoSublimite"}>Simples Nacional — Excesso de sublimite de receita bruta</MenuItem>
                                <MenuItem value={"regimeNormal"}>Regime Normal (Lucro Presumido ou Lucro Real)</MenuItem>
                                <MenuItem value={"simplesNacionalMEI"}>Simples Nacional - MEI</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl size="small">
                            <InputLabel id="regime-especial-label">Regime tributário especial</InputLabel>
                            <Select
                                labelId="regime-especial-label"
                                value={regimeTributarioEspecialEmpresa}
                                label="Regime tributário especial"
                                onChange={e => setRegimeTributarioEspecialEmpresa(e.target.value)}
                            >
                                <MenuItem value={"municipalMicroenterprise"}>Microempresa Municipal</MenuItem>
                                <MenuItem value={"estimate"}>Estimativa</MenuItem>
                                <MenuItem value={"societyOfProfessionals"}>Sociedade de Profissionais</MenuItem>
                                <MenuItem value={"cooperative"}>Cooperativa</MenuItem>
                                <MenuItem value={"individualMicroenterprise"}>Microempresário Individual (MEI)</MenuItem>
                                <MenuItem value={"microenterpriseAndSmallBusiness"}>Microempresário e Empresa de Pequeno Porte (ME EPP)</MenuItem>
                                <MenuItem value={"noSpecialRegime"}>Sem Regime Especial</MenuItem>
                                <MenuItem value={"others"}>Outros</MenuItem>
                            </Select>
                        </FormControl>
                    </FieldGrid>
                    <FormControl size="small" fullWidth>
                        <InputLabel id="regime-apuracao-label">Regime de apuração dos tributos do Simples Nacional</InputLabel>
                        <Select
                            labelId="regime-apuracao-label"
                            value={regimeApuracaoTributariaEmpresa}
                            label="Regime de apuração dos tributos do Simples Nacional"
                            onChange={e => setRegimeApuracaoTributariaEmpresa(e.target.value)}
                        >
                            <MenuItem value={"federalAndMunicipalBySimplesNacional"}>Regime de apuração dos tributos federais e municipal pelo Simples Nacional</MenuItem>
                            <MenuItem value={"federalBySimplesAndIssqnByNfse"}>Regime de apuração dos tributos federais pelo Simples Nacional e o ISSQN pela NFS-e conforme legislação municipal</MenuItem>
                            <MenuItem value={"federalAndMunicipalByNfse"}>Regime de apuração dos tributos federais e municipal pela NFS-e conforme legislações federal e municipal</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </SectionCard>

            <SectionCard
                title="Configurações de emissão"
                description="Série e numeração utilizadas na próxima nota."
                footer={<Button disabled={!empresa} variant="contained" onClick={handleSaveCompanyConfig} loading={empresaLoading}>Salvar alterações</Button>}
            >
                <FieldGrid>
                    <TextField size="small" disabled={!empresa} label="Série" value={serie ?? ''} onChange={e => setSerie(e.target.value)} />
                    <TextField size="small" disabled={!empresa} label="Número do próximo RPS/DPS ou NFS-e" value={nextNumeroNota ?? ''} onChange={e => setNextNumeroNota(e.target.value)} />
                </FieldGrid>
            </SectionCard>

            <SectionCard
                title="Certificado digital"
                description={certificado
                    ? "O cliente possui um certificado digital. Para atualizá-lo, envie um novo arquivo abaixo."
                    : "O cliente não possui certificado digital ativo."}
                status={<StatusChip label={statusCertificado} tone={toneCertificado} />}
                footer={<Button disabled={!empresa} variant="contained" onClick={handleSaveCertificado} loading={certificadoLoading}>Salvar certificado</Button>}
            >
                {!empresa && (
                    <Alert severity="info" variant="outlined" sx={{ mb: 2 }}>
                        Para enviar o certificado é necessário cadastrar a empresa.
                    </Alert>
                )}

                {certificado && (
                    <Box sx={{ mb: 3, p: 2, borderRadius: 2, border: "1px solid", borderColor: "divider", bgcolor: "#FCFCFD", display: "flex", gap: 2, alignItems: "flex-start" }}>
                        <Box sx={{ width: 40, height: 40, borderRadius: 2, bgcolor: "#ECFDF3", color: "success.main", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                            <VerifiedUserIcon fontSize="small" />
                        </Box>
                        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(4, 1fr)" }, gap: 2, flex: 1 }}>
                            <InfoItem label="Titular" value={certificado?.titular} />
                            <InfoItem label="Emissor" value={certificado?.emissor} />
                            <InfoItem
                                label="Data de expiração"
                                value={certificado?.dataExpiracao ? new Date(certificado.dataExpiracao).toLocaleDateString("pt-BR") : null}
                            />
                            <InfoItem label="Status" value={statusCertificado} />
                        </Box>
                    </Box>
                )}

                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Arquivo do certificado (.pfx ou .p12)
                </Typography>
                <Box
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    onClick={() => empresa && fileInputRef.current?.click()}
                    sx={{
                        border: "1.5px dashed",
                        borderRadius: 2,
                        p: 3,
                        textAlign: "center",
                        cursor: empresa ? "pointer" : "not-allowed",
                        opacity: empresa ? 1 : 0.6,
                        borderColor: isDragging ? "secondary.main" : "#D0D5DD",
                        backgroundColor: isDragging ? "#F6FEF9" : "#FCFCFD",
                        transition: "border-color 150ms, background-color 150ms",
                    }}
                >
                    {file ? (
                        <Typography variant="body1" sx={{ fontWeight: 600 }}>
                            {file.name}
                            <Typography component="span" variant="body2" color="text.secondary" sx={{ display: "block", fontWeight: 400, mt: 0.5 }}>
                                Clique para trocar o arquivo
                            </Typography>
                        </Typography>
                    ) : (
                        <>
                            <UploadFileIcon sx={{ color: "text.secondary", mb: 1 }} />
                            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                Arraste e solte o arquivo do certificado aqui
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ my: 1 }}>
                                ou
                            </Typography>
                            <Button variant="outlined" size="small" disabled={!empresa} onClick={(e) => { e.stopPropagation(); fileInputRef.current?.click(); }}>
                                Procurar arquivo
                            </Button>
                        </>
                    )}
                    <input
                        disabled={!empresa}
                        type="file"
                        accept=".pfx,.p12"
                        ref={fileInputRef}
                        onChange={handleFileSelect}
                        style={{ display: "none" }}
                    />
                </Box>

                <FieldGrid sx={{ mt: 2.5 }}>
                    <FormControl fullWidth size="small" variant="outlined" autoComplete="off">
                        <InputLabel htmlFor="senha-certificado">Senha do certificado</InputLabel>
                        <OutlinedInput
                            id="senha-certificado"
                            name="fakepassword"
                            value={senha}
                            disabled={!empresa}
                            onChange={(e) => setSenha(e.target.value)}
                            type={showPassword ? "text" : "password"}
                            autoComplete="new-password"
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                        size="small"
                                        aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                                    >
                                        {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="Senha do certificado"
                        />
                        <FormHelperText>
                            Necessária para validar o arquivo do certificado.
                        </FormHelperText>
                    </FormControl>
                    <FormControl fullWidth size="small" variant="outlined">
                        <InputLabel>E-mail para notificação</InputLabel>
                        <OutlinedInput
                            value={userInfo?.Email || ''}
                            disabled
                            type="email"
                            autoComplete="off"
                            endAdornment={
                                <InputAdornment position="end">
                                    <EmailIcon fontSize="small" />
                                </InputAdornment>
                            }
                            label="E-mail para notificação"
                        />
                        <FormHelperText>
                            Avisaremos este e-mail quando o certificado estiver próximo do vencimento.
                        </FormHelperText>
                    </FormControl>
                </FieldGrid>
            </SectionCard>

            <SectionCard
                title="Serviços do cliente"
                description="Cadastre os principais serviços do cliente para agilizar a emissão. Caso o serviço não esteja na lista, acione o TI."
            >
                <TableContainer sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ width: 80 }}>ID</TableCell>
                                <TableCell sx={{ width: 120 }}>Código</TableCell>
                                <TableCell>Discriminação</TableCell>
                                <TableCell align="right" sx={{ width: 80 }}>Ações</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {servicos.length > 0 ? (
                                servicos.map((servico) => (
                                    <TableRow key={servico.idServico} hover>
                                        <TableCell>#{servico.idServico}</TableCell>
                                        <TableCell sx={{ fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace" }}>{formatarCodigoServico(servico.codigo)}</TableCell>
                                        <TableCell>{servico.discriminacao}</TableCell>
                                        <TableCell align="right">
                                            <Tooltip title="Remover serviço">
                                                <span>
                                                    <IconButton size="small" color="error" disabled={servicoLoading} onClick={() => handleDeleteService(servico)}>
                                                        <DeleteOutlineIcon fontSize="small" />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={4} align="center" sx={{ py: 4, color: "text.secondary" }}>
                                        Nenhum serviço cadastrado.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box sx={{ mt: 2.5, display: "flex", gap: 1.5, flexDirection: { xs: "column", md: "row" } }}>
                    <Autocomplete
                        size="small"
                        disablePortal
                        options={servicesCode}
                        getOptionLabel={(option) => `${formatarCodigoServico(option.code)} - ${option.description.at(0).toUpperCase() + option.description.slice(1)}`}
                        value={servicesCode.find((option) => option.code === servicoASerAdicionado?.code) || null}
                        onChange={(event, newValue) => {
                            if (newValue) {
                                setServicoASerAdicionado(newValue);
                            }
                        }}
                        fullWidth
                        renderInput={(params) => <TextField {...params} label="Buscar serviço para adicionar" />}
                    />
                    <Button variant="contained" startIcon={<AddIcon />} onClick={handleSaveServico} loading={servicoLoading} sx={{ flexShrink: 0 }}>
                        Adicionar serviço
                    </Button>
                </Box>
            </SectionCard>
        </Box>
    );

    const abaCadastro = (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <SectionCard
                title="Informações do usuário"
                description="Dados de acesso do cliente à plataforma."
                footer={
                    <Tooltip title="Em desenvolvimento">
                        <span>
                            <Button variant="contained" disabled onClick={(handleSaveUserInfo)}>Salvar alterações</Button>
                        </span>
                    </Tooltip>
                }
            >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <FieldGrid>
                        <TextField size="small" label="Nome" value={userInfo?.Nome || ''} onChange={(e) => setUserInfo({ ...userInfo, Nome: e.target.value })} />
                        <TextField size="small" label="E-mail" value={userInfo?.Email || ''} onChange={(e) => setUserInfo({ ...userInfo, Email: e.target.value })} />
                    </FieldGrid>
                    <FieldGrid>
                        <TextField size="small" label="CPF" value={MascaraCpf(userInfo?.Cpf)} onChange={e => setUserInfo({ ...userInfo, Cpf: e.target.value.replaceAll(/\D/g, '') })} slotProps={{ htmlInput: { maxLength: 14 } }} />
                        <TextField size="small" label="Telefone" value={MascaraTelefone(userInfo?.Telefone)} onChange={e => setUserInfo({ ...userInfo, Telefone: e.target.value.replaceAll(/\D/g, '') })} slotProps={{ htmlInput: { maxLength: 15 } }} />
                    </FieldGrid>
                </Box>
            </SectionCard>

            <SectionCard
                title="Ficha cadastral"
                description={fichaCadastral.length === 0
                    ? "Nenhuma ficha preenchida pelo cliente."
                    : `${fichasCompletas} de ${fichaCadastral.length} ficha(s) completa(s).`}
                status={
                    <StatusChip
                        label={fichaCadastral.length > 0 && fichasCompletas === fichaCadastral.length ? "Completa" : "Pendente"}
                        tone={fichaCadastral.length > 0 && fichasCompletas === fichaCadastral.length ? "success" : "warning"}
                    />
                }
            >
                {fichaCadastral.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        O cliente ainda não preencheu nenhuma ficha cadastral.
                    </Typography>
                ) : (
                    fichaCadastral.map((ficha, index) => (
                        <Accordion
                            key={ficha?.id ?? index}
                            defaultExpanded={fichaCadastral.length === 1}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, width: "100%", flexWrap: "wrap" }}>
                                    <Typography variant="body2" sx={{ fontWeight: 600, color: "text.primary" }}>
                                        Ficha {index + 1}
                                    </Typography>

                                    <Typography variant="body2" color="text.secondary">
                                        {[ficha?.nome, ficha?.razaoSocial || ficha?.cnpj]
                                            .filter(Boolean)
                                            .join(" • ") || "Sem identificação"}
                                    </Typography>

                                    <Box sx={{ ml: "auto", mr: 1 }}>
                                        <StatusChip
                                            label={ficha?.progress === 100 ? "Completa" : `${ficha?.progress ?? 0}% preenchida`}
                                            tone={ficha?.progress === 100 ? "success" : "warning"}
                                        />
                                    </Box>
                                </Box>
                            </AccordionSummary>

                            <AccordionDetails sx={{ borderTop: "1px solid", borderColor: "divider", pt: 2 }}>
                                <FichaCadastralDetalhes ficha={ficha} />
                            </AccordionDetails>
                        </Accordion>
                    ))
                )}
            </SectionCard>

            <SectionCard
                title="Documentos dos sócios"
                description={socios.length === 0
                    ? "Nenhum sócio cadastrado."
                    : `${documentosAprovados} de ${todosDocumentosSocios.length} documento(s) aprovado(s)${documentosEmAnalise > 0 ? ` • ${documentosEmAnalise} aguardando análise` : ""}.`}
                status={documentosEmAnalise > 0 ? <StatusChip label={`${documentosEmAnalise} para analisar`} tone="info" /> : null}
            >
                {socios.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        O cliente ainda não possui sócios cadastrados.
                    </Typography>
                ) : (
                    socios.map((socio, index) => {
                        const documentos = socio?.documentos ?? [];
                        const aprovados = documentos.filter((doc) => doc?.status === "Aprovado").length;
                        const emAnalise = documentos.filter((doc) => doc?.status === "Em Análise").length;

                        return (
                            <Accordion
                                key={socio?.idFichaCadastral ?? index}
                                defaultExpanded={socios.length === 1}
                            >
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, width: "100%", flexWrap: "wrap" }}>
                                        <Typography variant="body2" sx={{ fontWeight: 600, color: "text.primary" }}>
                                            {socio?.nome || `Sócio ${index + 1}`}
                                        </Typography>

                                        <Typography variant="body2" color="text.secondary">
                                            {[
                                                socio?.cpf,
                                                socio?.percentual != null ? `${Number(socio.percentual).toLocaleString("pt-BR")}%` : null,
                                            ]
                                                .filter(Boolean)
                                                .join(" • ")}
                                        </Typography>

                                        <Box sx={{ ml: "auto", mr: 1, display: "flex", gap: 0.75 }}>
                                            {emAnalise > 0 && (
                                                <StatusChip label={`${emAnalise} em análise`} tone="info" />
                                            )}
                                            <StatusChip
                                                label={`${aprovados}/${documentos.length} aprovados`}
                                                tone={documentos.length > 0 && aprovados === documentos.length ? "success" : "warning"}
                                            />
                                        </Box>
                                    </Box>
                                </AccordionSummary>

                                <AccordionDetails sx={{ borderTop: "1px solid", borderColor: "divider", pt: 2 }}>
                                    <DocumentosSocio
                                        socio={socio}
                                        documentos={documentos}
                                        motivosRejeicao={motivosRejeicao}
                                        chaveDocumento={chaveDocumento}
                                        documentoEmAvaliacao={documentoEmAvaliacao}
                                        onMotivoChange={handleMotivoRejeicaoChange}
                                        onAvaliar={handleAvaliarDoc}
                                        onOpenImage={openModal}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        );
                    })
                )}
            </SectionCard>

            <SectionCard
                title="Contrato social"
                description={showContratoSocial
                    ? "Envie um novo PDF para sobrescrever o arquivo existente."
                    : "Clique para enviar ou substituir o contrato social."}
                status={<StatusChip label={contratoSocialEnviado ? "Enviado" : "Não enviado"} tone={contratoSocialEnviado ? "success" : "error"} />}
                collapsible
                open={showContratoSocial}
                onToggle={() => setShowContratoSocial((prev) => !prev)}
            >
                <Box
                    sx={{
                        border: "1.5px dashed #D0D5DD",
                        borderRadius: 2,
                        p: 3,
                        bgcolor: "#FCFCFD",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 1.5,
                    }}
                >
                    <PictureAsPdfOutlinedIcon sx={{ color: "text.secondary" }} />
                    <Typography variant="body2" color="text.secondary" textAlign="center">
                        Selecione um arquivo em PDF para anexar.
                    </Typography>

                    <Button component="label" variant="outlined" size="small" startIcon={<UploadFileIcon fontSize="small" />}>
                        Escolher PDF
                        <input
                            accept="application/pdf"
                            type="file"
                            hidden
                            onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                    setContratoSocial(file);
                                }
                                e.target.value = "";
                            }}
                        />
                    </Button>

                    {contratoSocial && (
                        <Box
                            sx={{
                                width: "100%",
                                mt: 1,
                                p: 1.5,
                                borderRadius: 1.5,
                                bgcolor: "background.paper",
                                border: "1px solid",
                                borderColor: "divider",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 2,
                            }}
                        >
                            <Box display="flex" alignItems="center" gap={1.5} sx={{ minWidth: 0 }}>
                                <PictureAsPdfOutlinedIcon sx={{ color: "error.main" }} />
                                <Box sx={{ minWidth: 0 }}>
                                    <Typography variant="body2" fontWeight={600} noWrap>
                                        {contratoSocial.name}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {(contratoSocial.size / 1024 / 1024).toFixed(2)} MB
                                    </Typography>
                                </Box>
                            </Box>

                            <Button
                                variant="contained"
                                size="small"
                                onClick={enviarContratoSocial}
                                disabled={!contratoSocial}
                                loading={contratoLoading}
                            >
                                Enviar
                            </Button>
                        </Box>
                    )}
                </Box>
            </SectionCard>

            <SectionCard
                title="Endereço fiscal"
                description={enderecoFiscal ? "O cliente contratou o serviço de endereço fiscal." : "O cliente não contratou o serviço de endereço fiscal."}
                status={<StatusChip label={enderecoFiscal ? "Contratado" : "Não contratado"} tone={enderecoFiscal ? "success" : "neutral"} />}
            />
        </Box>
    );

    const abaMovimentacoes = (
        <SectionCard
            title="Movimentações bancárias"
            description="Movimentações enviadas pelas contas conectadas do cliente."
        >
            <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start", gap: 1.5, flexWrap: "wrap", mb: 2.5 }}>
                <TextField
                    label="Data inicial"
                    type="datetime-local"
                    size="small"
                    slotProps={{ inputLabel: { shrink: true } }}
                    sx={{ width: { xs: "100%", sm: 220 } }}
                    value={dataInicial}
                    onChange={(e) => setDataInicial(e.target.value)}
                />

                <TextField
                    label="Data final"
                    type="datetime-local"
                    size="small"
                    slotProps={{ inputLabel: { shrink: true } }}
                    sx={{ width: { xs: "100%", sm: 220 } }}
                    value={dataFinal}
                    onChange={(e) => setDataFinal(e.target.value)}
                />

                <Button
                    variant="contained"
                    startIcon={<SearchIcon />}
                    loading={loadingTransacoes}
                    onClick={handleFindTransactions}
                    sx={{ height: 40 }}
                >
                    Buscar
                </Button>
            </Box>

            {transacoesUsuario.length > 0 ? (
                transacoesUsuario.map((banco, indexBanco) => {

                    const paginaAtual = paginas[indexBanco] || 0;

                    const transacoes = banco?.transacoes || [];

                    const inicio = paginaAtual * linhasPorPagina;

                    const transacoesPagina = transacoes.slice(
                        inicio,
                        inicio + linhasPorPagina
                    );

                    return (
                        <Accordion
                            key={indexBanco}
                            expanded={expanded === `panel${indexBanco}`}
                            onChange={handleChange(`panel${indexBanco}`)}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${indexBanco}-content`}
                                id={`panel${indexBanco}-header`}
                            >
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, width: "100%" }}>
                                    {banco?.banco?.logo && (
                                        <Box
                                            component="img"
                                            src={banco.banco.logo}
                                            alt={banco.banco.nome}
                                            sx={{ width: 28, height: 28, objectFit: "contain", borderRadius: 1 }}
                                        />
                                    )}

                                    <Typography variant="body2" sx={{ fontWeight: 600, color: "text.primary" }}>
                                        {banco?.banco?.nome}
                                    </Typography>

                                    <Typography variant="body2" color="text.secondary" sx={{ ml: "auto", mr: 1.5 }}>
                                        {transacoes.length} movimentações
                                    </Typography>
                                </Box>
                            </AccordionSummary>

                            <AccordionDetails sx={{ p: 0, borderTop: "1px solid", borderColor: "divider" }}>
                                <TableContainer sx={{ borderRadius: 0 }}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Data</TableCell>
                                                <TableCell>Descrição</TableCell>
                                                <TableCell>Categoria</TableCell>
                                                <TableCell>Tipo</TableCell>
                                                <TableCell align="right">Valor</TableCell>
                                                <TableCell align="right">Saldo</TableCell>
                                                <TableCell align="center">Status</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {transacoesPagina.map((transacao) => {

                                                const valor = Number(
                                                    transacao.valor
                                                );

                                                const entrada = valor >= 0;

                                                return (
                                                    <TableRow
                                                        key={
                                                            transacao.idTransacaoBancaria
                                                        }
                                                        hover
                                                    >
                                                        <TableCell sx={{ whiteSpace: "nowrap" }}>
                                                            {new Date(
                                                                transacao.dataTransacao
                                                            ).toLocaleDateString(
                                                                "pt-BR"
                                                            )}
                                                        </TableCell>

                                                        <TableCell sx={{ fontWeight: 500 }}>
                                                            {transacao.descricao ||
                                                                "Sem descrição"}
                                                        </TableCell>

                                                        <TableCell>
                                                            {transacao.categoria || "-"}
                                                        </TableCell>

                                                        <TableCell>
                                                            <StatusChip
                                                                label={entrada ? "Entrada" : "Saída"}
                                                                tone={entrada ? "success" : "error"}
                                                            />
                                                        </TableCell>

                                                        <TableCell
                                                            align="right"
                                                            sx={{
                                                                fontWeight: 600,
                                                                whiteSpace: "nowrap",
                                                                fontVariantNumeric: "tabular-nums",
                                                                color: entrada
                                                                    ? "success.main"
                                                                    : "error.main"
                                                            }}
                                                        >
                                                            {valor.toLocaleString(
                                                                "pt-BR",
                                                                {
                                                                    style: "currency",
                                                                    currency:
                                                                        transacao.codigoMoeda ||
                                                                        "BRL"
                                                                }
                                                            )}
                                                        </TableCell>

                                                        <TableCell align="right" sx={{ whiteSpace: "nowrap", fontVariantNumeric: "tabular-nums" }}>
                                                            {transacao.saldo != null
                                                                ? Number(
                                                                    transacao.saldo
                                                                ).toLocaleString(
                                                                    "pt-BR",
                                                                    {
                                                                        style: "currency",
                                                                        currency:
                                                                            transacao.codigoMoeda ||
                                                                            "BRL"
                                                                    }
                                                                )
                                                                : "-"}
                                                        </TableCell>

                                                        <TableCell align="center">
                                                            <Chip
                                                                label={
                                                                    transacao.status ||
                                                                    "N/A"
                                                                }
                                                                size="small"
                                                                variant="outlined"
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}

                                            {transacoes.length === 0 && (
                                                <TableRow>
                                                    <TableCell
                                                        colSpan={7}
                                                        align="center"
                                                        sx={{ py: 4, color: "text.secondary" }}
                                                    >
                                                        Nenhuma movimentação encontrada.
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>

                                    <TablePagination
                                        component="div"
                                        count={transacoes.length}
                                        page={paginaAtual}
                                        onPageChange={(event, novaPagina) =>
                                            handleChangePagina(
                                                indexBanco,
                                                novaPagina
                                            )
                                        }
                                        rowsPerPage={linhasPorPagina}
                                        onRowsPerPageChange={
                                            handleChangeLinhasPorPagina
                                        }
                                        rowsPerPageOptions={[
                                            5,
                                            10,
                                            25,
                                            50
                                        ]}
                                        labelRowsPerPage="Registros por página:"
                                        labelDisplayedRows={({
                                            from,
                                            to,
                                            count
                                        }) =>
                                            `${from}-${to} de ${count}`
                                        }
                                    />
                                </TableContainer>
                            </AccordionDetails>
                        </Accordion>
                    );
                })
            ) : (
                <Box sx={{ py: 5, textAlign: "center", border: "1px dashed", borderColor: "divider", borderRadius: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        {buscouTransacoes
                            ? "Nenhuma transação encontrada no período informado."
                            : "Informe o período e clique em Buscar para consultar as movimentações."}
                    </Typography>
                </Box>
            )}
        </SectionCard>
    );

    return (
        <PageLayout
            title={userInfo?.Nome || (perfilLoading ? "Carregando perfil..." : "Perfil do cliente")}
            subtitle={subtituloPerfil || "Dados do cliente"}
            breadcrumbs={[{ label: 'Dashboard', to: '/dashboard' }, { label: 'Emitir Nota', to: '/emitirNota' }, { label: 'Perfil do cliente' }]}
        >
            {faturasVencidas.length > 0 && (
                <FaturasVencidasAlert faturas={faturasVencidas} />
            )}

            <Card sx={{ mb: 2.5 }}>
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(3, 1fr)", xl: "repeat(6, 1fr)" },
                    }}
                >
                    {resumoStatus.map((item, index) => (
                        <Box
                            key={item.label}
                            sx={{
                                px: 2.5,
                                py: 1.75,
                                borderRight: { xl: index < resumoStatus.length - 1 ? "1px solid" : 0 },
                                borderBottom: { xs: "1px solid", xl: 0 },
                                borderColor: { xs: "divider", xl: "divider" },
                            }}
                        >
                            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.75 }}>
                                {item.label}
                            </Typography>
                            <StatusChip label={item.value} tone={item.tone} />
                        </Box>
                    ))}
                </Box>
            </Card>

            <Box sx={{ borderBottom: "1px solid", borderColor: "divider", mb: 2.5 }}>
                <Tabs
                    value={abaAtual}
                    onChange={trocarAba}
                    variant="scrollable"
                    scrollButtons="auto"
                    textColor="inherit"
                    sx={{
                        minHeight: 40,
                        "& .MuiTab-root": { minHeight: 40, px: 1.5, mr: 1, fontSize: "0.8125rem", fontWeight: 600, color: "text.secondary", textTransform: "none" },
                        "& .MuiTab-root.Mui-selected": { color: "text.primary" },
                        "& .MuiTabs-indicator": { backgroundColor: "text.primary", height: 2 },
                    }}
                >
                    <Tab value="emissao" label="Emissão de NFS-e" />
                    <Tab value="empresa" label="Empresa e certificado" />
                    <Tab value="cadastro" label={documentosEmAnalise > 0 ? `Cadastro e documentos (${documentosEmAnalise})` : "Cadastro e documentos"} />
                    <Tab value="movimentacoes" label="Movimentações bancárias" />
                </Tabs>
            </Box>

            {abaAtual === "emissao" && abaEmissao}
            {abaAtual === "empresa" && abaEmpresa}
            {abaAtual === "cadastro" && abaCadastro}
            {abaAtual === "movimentacoes" && abaMovimentacoes}

            <ModalImage
                open={modalOpen}
                onClose={closeModal}
                imageUrl={selectedImage}
            />
            <MotivoCancelamentoNfse
                openModalMotivoCancelamento={openModalMotivoCancelamento}
                setOpenModalMotivoCancelamento={setOpenModalMotivoCancelamento}
                idNota={idNotaSelecionadaParaCancelamento}
                handleCancelNfse={handleCancelNfse}
            />
        </PageLayout>
    );
}

// Aviso de faturas vencidas e não pagas do cliente.
const FaturasVencidasAlert = ({ faturas }) => {
    const totalVencido = faturas.reduce((s, f) => s + Number(f.valor || 0), 0);

    return (
        <Alert severity="error" variant="outlined" sx={{ mb: 2.5, bgcolor: "background.paper" }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Cliente com {faturas.length} fatura(s) vencida(s), totalizando {formatToBrl(totalVencido)}.
            </Typography>
            <Box component="ul" sx={{ m: 0, mt: 0.75, pl: 2.5 }}>
                {faturas.map((f) => {
                    return (
                        <Box component="li" key={f.idCobranca} sx={{ fontSize: "0.8125rem", py: 0.25 }}>
                            <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                                <span>Vencimento {f.dataVencimento ? FormatDate(f.dataVencimento) : "—"} · {formatToBrl(f.valor)}{f.descricao ? ` · ${f.descricao}` : ""}</span>
                                {f.linkFatura && (
                                    <Button size="small" href={f.linkFatura} target="_blank" rel="noopener noreferrer" endIcon={<OpenInNewIcon sx={{ fontSize: 14 }} />} sx={{ py: 0, minWidth: 0 }}>
                                        Ver fatura
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </Alert>
    );
};

const InfoItem = ({ label, value }) => (
    <Box sx={{ minWidth: 0 }}>
        <Typography variant="caption" color="text.secondary">{label}</Typography>
        <Typography variant="body2" sx={{ fontWeight: 600, color: "text.primary", wordBreak: "break-word" }}>{value || "-"}</Typography>
    </Box>
);

const SecaoFicha = ({ titulo, children }) => {
    return (
        <Box sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2, p: 2 }}>
            <Typography variant="overline" color="text.secondary" sx={{ display: "block", mb: 1 }}>
                {titulo}
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
                {children}
            </Box>
        </Box>
    );
};

const FichaCadastralDetalhes = ({ ficha }) => {
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                gap: 2,
            }}
        >
            <SecaoFicha titulo="Informações pessoais">
                <ResumoItem label="Nome" value={ficha?.nome} />
                <ResumoItem label="CPF" value={ficha?.cpf} />
                <ResumoItem label="Data de nascimento" value={FormatarData(ficha?.dataNascimento)} />
                <ResumoItem label="RG" value={ficha?.rg} />
                <ResumoItem label="Órgão RG" value={ficha?.orgaoRg} />
                <ResumoItem label="Naturalidade" value={ficha?.naturalidade} />
            </SecaoFicha>

            <SecaoFicha titulo="Contato">
                <ResumoItem label="E-mail" value={ficha?.email} />
                <ResumoItem label="Telefone" value={ficha?.telefone} />
            </SecaoFicha>

            <SecaoFicha titulo="Endereço">
                <ResumoItem label="CEP" value={ficha?.cep} />
                <ResumoItem
                    label="Endereço"
                    value={[
                        ficha?.rua,
                        ficha?.numero,
                        ficha?.bairro,
                        ficha?.cidade,
                        ficha?.estado,
                    ]
                        .filter(Boolean)
                        .join(", ")}
                />
                <ResumoItem label="Complemento" value={ficha?.complemento} />
            </SecaoFicha>

            <SecaoFicha titulo="Status conjugal">
                <ResumoItem label="Estado civil" value={ficha?.estadoCivil} />
                <ResumoItem label="Regime de bens" value={ficha?.regimeBens} />
                <ResumoItem label="CPF do cônjuge" value={ficha?.cpfConjugue} />
            </SecaoFicha>

            <SecaoFicha titulo="Empresa">
                <ResumoItem label="CNPJ" value={ficha?.cnpj} />
                <ResumoItem label="Razão Social" value={ficha?.razaoSocial} />
                <ResumoItem label="Nome Fantasia" value={ficha?.nomeFantasia} />
                <ResumoItem label="Endereço Fiscal" value={ficha?.enderecoFiscal} />
                <ResumoItem label="Senha Gov" value={ficha?.senhaGov} sensivel />
            </SecaoFicha>

            <SecaoFicha titulo="Participação societária">
                <ResumoItem
                    label="Participação"
                    value={ficha?.percentual != null ? `${ficha.percentual}%` : null}
                />
                <ResumoItem
                    label="Capital Social"
                    value={
                        ficha?.capitalSocial != null
                            ? `R$ ${Number(ficha.capitalSocial).toLocaleString("pt-BR", {
                                minimumFractionDigits: 2,
                            })}`
                            : null
                    }
                />
            </SecaoFicha>
        </Box>
    );
};

const ResumoItem = ({ label, value, sensivel = false }) => {
    const [visivel, setVisivel] = useState(false);
    const valorExibido = !value ? "Não informado" : sensivel && !visivel ? "••••••••" : value;

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, flexShrink: 0 }}>
                {label}
            </Typography>

            <Typography variant="body2" sx={{ color: value ? "text.primary" : "text.disabled", fontWeight: 500, wordBreak: "break-word" }}>
                {valorExibido}
            </Typography>

            {sensivel && value && (
                <Tooltip title={visivel ? "Ocultar" : "Mostrar"}>
                    <IconButton size="small" onClick={() => setVisivel((v) => !v)} sx={{ p: 0.25 }}>
                        {visivel ? <VisibilityOff sx={{ fontSize: 16 }} /> : <Visibility sx={{ fontSize: 16 }} />}
                    </IconButton>
                </Tooltip>
            )}
        </Box>
    );
};

const STATUS_DOCUMENTO = {
    "Aprovado": "success",
    "Em Análise": "info",
    "Reprovado": "error",
    "Pendente": "neutral",
};

const isPdf = (url) => (url ?? "").split("?")[0].toLowerCase().endsWith(".pdf");

const DocumentosSocio = ({ socio, documentos, motivosRejeicao, chaveDocumento, documentoEmAvaliacao, onMotivoChange, onAvaliar, onOpenImage }) => {
    if (documentos.length === 0) {
        return (
            <Typography variant="body2" color="text.secondary">
                Nenhum documento cadastrado.
            </Typography>
        );
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            {documentos.map((documento) => {
                const chave = chaveDocumento(socio, documento);

                return (
                    <DocumentoSocioCard
                        key={chave}
                        documento={documento}
                        motivo={motivosRejeicao[chave] ?? ""}
                        emAvaliacao={documentoEmAvaliacao === chave}
                        onMotivoChange={(valor) => onMotivoChange(socio, documento, valor)}
                        onAceitar={() => onAvaliar("aceitar", socio, documento)}
                        onRejeitar={() => onAvaliar("rejeitar", socio, documento)}
                        onOpenImage={onOpenImage}
                    />
                );
            })}
        </Box>
    );
};

const DocumentoSocioCard = ({ documento, motivo, emAvaliacao, onMotivoChange, onAceitar, onRejeitar, onOpenImage }) => {
    const { label, tipo, url, status, motivoRejeicao } = documento ?? {};
    const podeAvaliar = Boolean(url) && status === "Em Análise";

    return (
        <Box
            sx={{
                p: 2,
                borderRadius: 2,
                border: "1px solid",
                borderColor: podeAvaliar ? "#B2DDFF" : "divider",
                backgroundColor: "background.paper",
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: url || motivoRejeicao ? 1.5 : 0 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, color: "text.primary" }}>
                    {label || tipo}
                </Typography>

                {url && (
                    <Tooltip title="Abrir em nova aba">
                        <IconButton size="small" component="a" href={url} target="_blank" rel="noopener noreferrer">
                            <OpenInNewIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                    </Tooltip>
                )}

                <Box sx={{ ml: "auto" }}>
                    <StatusChip label={status || "Pendente"} tone={STATUS_DOCUMENTO[status] ?? "neutral"} />
                </Box>
            </Box>

            {status === "Reprovado" && motivoRejeicao && (
                <Alert severity="error" variant="outlined" sx={{ mb: url ? 1.5 : 0, py: 0 }}>
                    Motivo da reprovação: {motivoRejeicao}
                </Alert>
            )}

            {url ? (
                <Box sx={{ display: "flex", gap: 2, flexWrap: { xs: "wrap", md: "nowrap" } }}>
                    <Box sx={{ flex: 1, minWidth: 0, position: "relative" }}>
                        {isPdf(url) ? (
                            <Box
                                onClick={() => onOpenImage(url)}
                                sx={{
                                    position: "relative",
                                    width: "100%",
                                    height: 280,
                                    cursor: "pointer",
                                    borderRadius: 1.5,
                                    overflow: "hidden",
                                    border: "1px solid",
                                    borderColor: "divider",
                                    "&:hover .pdf-overlay": {
                                        opacity: 1,
                                    },
                                }}
                            >
                                <iframe
                                    src={url}
                                    title={label || tipo}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        border: "none",
                                        pointerEvents: "none",
                                    }}
                                />

                                {/* Camada para capturar o clique */}
                                <Box
                                    className="pdf-overlay"
                                    sx={{
                                        position: "absolute",
                                        inset: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        bgcolor: "rgba(16, 24, 40, 0.35)",
                                        opacity: 0,
                                        transition: "opacity .15s ease",
                                        pointerEvents: "none",
                                    }}
                                >
                                    <Box sx={{ bgcolor: "#FFF", color: "text.primary", px: 1.5, py: 0.75, borderRadius: 1.5, fontSize: 12, fontWeight: 600 }}>
                                        Clique para visualizar
                                    </Box>
                                </Box>
                            </Box>
                        ) : (
                            <Box
                                component="img"
                                src={url}
                                alt={label || tipo}
                                onClick={() => onOpenImage(url)}
                                sx={{
                                    width: "100%",
                                    maxHeight: 280,
                                    objectFit: "contain",
                                    borderRadius: 1.5,
                                    border: "1px solid",
                                    borderColor: "divider",
                                    bgcolor: "#FCFCFD",
                                    cursor: "zoom-in",
                                }}
                            />
                        )}
                    </Box>

                    {podeAvaliar && (
                        <Box sx={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
                            <TextField
                                fullWidth
                                label="Motivo da reprovação"
                                placeholder="O documento foi reprovado por: ..."
                                helperText="Obrigatório apenas para reprovar."
                                multiline
                                rows={4}
                                size="small"
                                sx={{ mb: 2 }}
                                value={motivo}
                                onChange={(e) => onMotivoChange(e.target.value)}
                                disabled={emAvaliacao}
                            />
                            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: "auto" }}>
                                <Button
                                    variant="outlined"
                                    color="error"
                                    size="small"
                                    disabled={emAvaliacao}
                                    onClick={onRejeitar}
                                >
                                    Reprovar documento
                                </Button>
                                <Button
                                    variant="contained"
                                    color="success"
                                    size="small"
                                    disabled={emAvaliacao}
                                    onClick={onAceitar}
                                >
                                    Aprovar documento
                                </Button>
                            </Box>
                        </Box>
                    )}
                </Box>
            ) : (
                status !== "Reprovado" && (
                    <Typography variant="body2" color="text.secondary">
                        Usuário não enviou o documento.
                    </Typography>
                )
            )}
        </Box>
    );
};


export default PerfilUsuario;
